import React, { useState, useContext } from "react";
import {
  TextInput,
  PasswordInput,
  Anchor,
  Paper,
  Title,
  Text,
  Container,
  Button,
} from "@mantine/core";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../context/User";
import { showNotification } from "@mantine/notifications";
const Login = () => {
  const { setIsLoggedIn, setUserInfo } = useContext(UserContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setsuccess] = useState("");

  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const handlelogin = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    axios
      .post("https://swipett.herokuapp.com/auth/login", {
        username,
        password,
      })
      .then((res) => {
        setIsLoggedIn(true);
        setUserInfo({
          username: res.data.user.username,
          avatar: res.data.user.avatar,
          desc: res.data.user.description,
        });
        localStorage.setItem("token", res.data.token);
        showNotification({
          title: "Login Successful",
          message: `Welcome back ${res.data.user.username}  🐱`,
        });

        history.push("/profile");
      })
      .catch((err) => {
        setError(err.response.data.message);
        setLoading(false);
      });
  };
  return (
    <div>
      <Container size={420} my={40}>
        <Title
          align="center"
          sx={(theme) => ({
            fontFamily: `Greycliff CF, ${theme.fontFamily}`,
            fontWeight: 900,
          })}
        >
          Welcome to Swipet 🐶
        </Title>
        <Text color="dimmed" size="sm" align="center" mt={5}>
          Do not have an account yet? {""}
          <Anchor
            size="sm"
            onClick={(event) => {
              event.preventDefault();
              history.push("/register");
            }}
          >
            Create account
          </Anchor>
        </Text>

        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          {error && (
            <Text color="red" size="sm" align="left" mt={5}>
              {error}
            </Text>
          )}
          {success && (
            <Text color="green" size="sm" align="left" mt={5}>
              {success}
            </Text>
          )}
          <form
            onSubmit={(e) => {
              handlelogin(e);
            }}
          >
            {" "}
            <TextInput
              onChange={(e) => {
                setUsername(e.target.value);
              }}
              label="Username"
              placeholder="Username"
              required
            />
            <PasswordInput
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              label="Password"
              placeholder="Password"
              required
              mt="md"
            />
            {loading ? (
              <Button disabled type="submit" fullWidth mt="xl">
                Sign in
              </Button>
            ) : (
              <Button type="submit" fullWidth mt="xl">
                Sign in
              </Button>
            )}
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default Login;
